import { render, staticRenderFns } from "./footer-common.vue?vue&type=template&id=c01707e8"
import script from "./footer-common.vue?vue&type=script&lang=js"
export * from "./footer-common.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports